import { useState } from "react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { KeyRound } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
  DialogTrigger,
} from "../ui/dialog";

export const AdminChangePassword = () => {
  const { changePassword } = useAuth();
  const [open, setOpen] = useState(false);
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const resetFields = () => {
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 8) {
      toast.error("La nueva contraseña debe tener al menos 8 caracteres");
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error("Las contraseñas nuevas no coinciden");
      return;
    }
    setLoading(true);
    const res = await changePassword(currentPassword, newPassword);
    setLoading(false);
    if (res.success) {
      toast.success("Contraseña actualizada correctamente");
      resetFields();
      setOpen(false);
    } else {
      toast.error(res.error || "No se pudo actualizar la contraseña");
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { setOpen(v); if (!v) resetFields(); }}>
      <DialogTrigger asChild>
        <Button data-testid="admin-open-change-password" variant="outline">
          <KeyRound size={16} className="mr-2" /> Cambiar contraseña
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="admin-change-password-dialog">
        <DialogHeader>
          <DialogTitle>Cambiar mi contraseña</DialogTitle>
          <DialogDescription>
            Ingresa tu contraseña actual y elige una nueva (mínimo 8 caracteres).
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <Label>Contraseña actual</Label>
            <Input
              data-testid="change-password-current"
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="mt-2"
              required
            />
          </div>
          <div>
            <Label>Nueva contraseña</Label>
            <Input
              data-testid="change-password-new"
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="mt-2"
              required
            />
          </div>
          <div>
            <Label>Confirmar nueva contraseña</Label>
            <Input
              data-testid="change-password-confirm"
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="mt-2"
              required
            />
          </div>
          <DialogFooter>
            <Button type="submit" data-testid="change-password-submit" disabled={loading}>
              {loading ? "Guardando..." : "Guardar nueva contraseña"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
